import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Pre-capture session_id from URL BEFORE React mounts.
// iOS Safari/Chrome sometimes clear window.location.hash after redirect chains,
// so we grab it synchronously from the full URL string as early as possible.
(function() {
  try {
    var href = window.location.href;
    var match = href.match(/[#&?]session_id=([a-f0-9-]+)/i);
    if (match) {
      window.__TASKMASTER_PENDING_SESSION = match[1];
    }
  } catch(e) {}
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
